import { Injectable } from '@angular/core';
import { CancelReason } from './core/interfaces/cancel-reason';
import { Patient } from './core/interfaces/patient';
import { TerminologyItem } from './core/interfaces/terminology-item';
import { AppointmentModel } from './core/models/appointment-model';
import { ColorLabel } from './core/interfaces/color-label';
import { PriceListCode } from './core/models/price-list-code';
import { VisitItem } from './core/models/visit-item';
import { FindTimeResultItem } from './core/models/find-time-result-item-model';
import { TreatmentType } from './core/enums';
import { TreatmentEntity } from './core/interfaces/treatment-entity';
import { TranslateService } from '@ngx-translate/core';
import { Arguments } from './core/models/arguments';
import { Utils } from './core/utils';
import { CustomerDetails } from './core/models/customer-details';
import { WaitlistModel } from './core/models/waitlist-model';
import { SelectListItem } from './core/models/select-list-item';
import { SchedulerModel } from './core/models/scheduler.model';


@Injectable({
  providedIn: 'root'
})
export class AppData {


  constructor(private translate: TranslateService) { }

  public ColorLabels: ColorLabel[] = [];
  public Schedulers: SchedulerModel[] = [];

  get appointment(): AppointmentModel {
    return JSON.parse(sessionStorage.getItem('appointment'));
  }
  set appointment(val: AppointmentModel | null) {

    if (val) {
      sessionStorage.setItem('appointment', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('appointment');
    }
  }

  get bookAppointment(): AppointmentModel {
    var str = sessionStorage.getItem('bookAppointment');
    var obj = str !== null ? JSON.parse(str) : null;
    return obj;
  }
  set bookAppointment(val: AppointmentModel) {
    if (val) {
      sessionStorage.setItem('bookAppointment', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('bookAppointment');
    }
  }

  get waitlistItem(): WaitlistModel {
    var str = sessionStorage.getItem('waitlistItem');
    return str !== null ? JSON.parse(str) : null;
  }
  set waitlistItem(val: WaitlistModel) {
    if (val) {
      sessionStorage.setItem('waitlistItem', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('waitlistItem');
    }
  }

  get terminology(): TerminologyItem[] {
    var str = sessionStorage.getItem('terminology');
    return str !== null ? JSON.parse(str) : null;
  }
  set terminology(val: TerminologyItem[]) {
    if (val) {
      sessionStorage.setItem('terminology', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('terminology');
    }
  }

  get patient(): Patient {
    var str = sessionStorage.getItem('patient');
    return str !== null ? JSON.parse(str) : null;    
  }
  set patient(val: Patient) {
    if (val) {
      sessionStorage.setItem('patient', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('patient');
    }
  }

  get customerDetails(): CustomerDetails {
    var str = sessionStorage.getItem('customerDetails');
    return str !== null ? JSON.parse(str) : null;   
  }
  set customerDetails(val: CustomerDetails) {
    if (val) {
      sessionStorage.setItem('customerDetails', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('customerDetails');
    }
  }

  get captureImageData(): any {
    var str = sessionStorage.getItem('captureImageData');
    return str !== null ? JSON.parse(str) : null;    
  }
  set captureImageData(val: any) {
    if (val) {
      sessionStorage.setItem('captureImageData', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('captureImageData');
    }
  }

  get cancelReasons(): CancelReason[] {
    var str = sessionStorage.getItem('cancelReasons');
    return str !== null ? JSON.parse(str) : null;       
  }
  set cancelReasons(val: CancelReason[]) {
    if (val) {
      sessionStorage.setItem('cancelReasons', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('cancelReasons');
    }
  }

  get previousUrl(): string {    
    return sessionStorage.getItem('previousUrl') ?? '';
  }
  set previousUrl(val: string) {
    if (val) {
      sessionStorage.setItem('previousUrl', val);
    } else {
      sessionStorage.removeItem('previousUrl');
    }
  }

  get arguments(): Arguments {    
    var str = sessionStorage.getItem('arguments');
    return str !== null ? JSON.parse(str) : null;
  }
  set arguments(item: Arguments) {
    if (item) {
      sessionStorage.setItem('arguments', JSON.stringify(item));
    } else {
      sessionStorage.removeItem('arguments');
    }
  }

  // save findTime form state
  get formStateFindTime(): any {
    var str = sessionStorage.getItem('find-time-state');
    return str !== null ? JSON.parse(str) : null;    
  }
  set formStateFindTime(formValue: any) {
    if (formValue) {
      sessionStorage.setItem('find-time-state', JSON.stringify(formValue));
    } else {
      sessionStorage.removeItem('find-time-state');
    }
  }

  get formStateStandby(): any {
    var str = sessionStorage.getItem('standby-state');
    return str !== null ? JSON.parse(str) : null;        
  }
  set formStateStandby(formValue: any) {
    if (formValue) {
      sessionStorage.setItem('standby-state', JSON.stringify(formValue));
    } else {
      sessionStorage.removeItem('standby-state');
    }
  }


  get priceListCodes(): PriceListCode[] {
    return JSON.parse(sessionStorage.getItem('priceListCode') || '[]');
  }
  set priceListCodes(items: PriceListCode[]) {
    if (items) {
      sessionStorage.setItem('priceListCode', JSON.stringify(items));
    } else {
      sessionStorage.removeItem('priceListCode');
    }
  }

  addToPriceListCodes(item: PriceListCode) {
    const list = this.priceListCodes || [];
    list.push(item);
    this.priceListCodes = list;
  }
  removeFromPriceListCodes(refID: number) {
    const list = this.priceListCodes || [];
    const index = list.map(x => x.PriceListRefID).indexOf(refID, 0);
    if (index > -1) {
      list.splice(index, 1);
      this.priceListCodes = list;
    }
  }
  priceListCodesContains(refID: number) :boolean {
    const list = this.priceListCodes || [];
    const index = list.map(x => x.PriceListRefID).indexOf(refID, 0);
    return index > -1;
  }

  /** get total duration from pricelistCodes and treatments */
  getDuration() {
    let duration = 0;
    const listA = this.priceListCodes || [];
    const listB = this.treatments || [];

    for (let index = 0; index < listA.length; index++) {
      const element = listA[index];
      duration += element.Duration;
    }

    for (let index = 0; index < listB.length; index++) {
      const element = listB[index];
      const priceListCode = element.PriceListCode;
      duration += priceListCode && priceListCode.Duration || 0;
    }
    return duration;
  }

  getTotal() {
    const listA = this.priceListCodes || [];
    const listB = this.treatments || [];

    const totalA = listA.map(item => item.FinalPrice || 0).reduce((a, b) => a + b, 0) || 0;
    const totalB = listB.map(item => item.Price || 0).reduce((a, b) => a + b, 0) || 0;
    return totalA + totalB;
  }

  treatmentsVisitSummary(treatments: TreatmentEntity[]): string[] {
    // return Utils.generateVisitReasonSummary1( this.treatments, this.translate);
    const summaryList: string[] = [];
    const list = treatments || [];
    list.forEach(element => {
      const msg = Utils.treatmentToString(element, this.translate);
      summaryList.push(msg);
    });
    return summaryList;
  }

  priceListCodeVisitSummary(priceListCodes: PriceListCode[]): string[] {
    // return Utils.generateVisitReasonSummary3( this.priceListCodes, this.translate);
    const summaryList: string[] = [];
    const list = priceListCodes || [];
    list.forEach(element => {
      const msg = Utils.priceListCodeToString(element, this.translate);
      summaryList.push(msg);
    });
    return summaryList;
  }

  visitSummary(treatments: TreatmentEntity[], priceListCodes: PriceListCode[]): string[] {
    const arr1: string[] = this.treatmentsVisitSummary(treatments);
    const arr2: string[] = this.priceListCodeVisitSummary(priceListCodes);
    return arr1.concat(arr2);
  }


  get treatments(): TreatmentEntity[] {
    return JSON.parse(sessionStorage.getItem('treatments') || '[]');
  }
  set treatments(items: TreatmentEntity[]) {
    if (items) {
      sessionStorage.setItem('treatments', JSON.stringify(items));
    } else {
      sessionStorage.removeItem('treatments');
    }
  }



  addToTreatments(item: TreatmentEntity) {
    const list = this.treatments || [];
    list.push(item);
    this.treatments = list;
  }
  removeFromTreatments(id: number) {
    const list = this.treatments || [];
    const index = list.map(x => x.ID).indexOf(id, 0);
    if (index > -1) {
      list.splice(index, 1);
      // this save the list in session
      this.treatments = list;
    }
  }
  treatmentsContains(id: number) {
    const list = this.treatments || [];
    const index = list.map(x => x.ID).indexOf(id, 0);
    return index > -1;
  }

  isSeriesSelected() {
    const pricelistCodes = this.priceListCodes || [];
    const treatments = this.treatments || [];
    let series = false;

    pricelistCodes.forEach(element => {
      if (element.TypeID === TreatmentType.Series) {
        series = true;
        return false; // break from loop
      }
    });
    treatments.forEach(element => {
      if (element.ParentTypeID === TreatmentType.Series) {
        series = true;
        return false; // break from loop
      }
    });
    return series;
  }

  get findTimeResult(): any[] {
    return JSON.parse(sessionStorage.getItem('findTimeResult') || '[]');
  }
  set findTimeResult(items: any[]) {
    if (items) {
      sessionStorage.setItem('findTimeResult', JSON.stringify(items));
    } else {
      sessionStorage.removeItem('findTimeResult');
    }
  }

  get findTimeGroupResult(): FindTimeResultItem[] {

    return JSON.parse(sessionStorage.getItem('findTimeGroupResult') || '[]');
  }
  set findTimeGroupResult(items: FindTimeResultItem[]) {
    if (items) {
      sessionStorage.setItem('findTimeGroupResult', JSON.stringify(items));
    } else {
      sessionStorage.removeItem('findTimeGroupResult');
    }
  }

  // find time first result grouped by day
  get selectedFindTimeResultItemGroup(): FindTimeResultItem {
    return JSON.parse(sessionStorage.getItem('selectedFindTimeResultItemGroup') || '[]');
  }
  set selectedFindTimeResultItemGroup(item: FindTimeResultItem) {
    if (item) {
      sessionStorage.setItem('selectedFindTimeResultItemGroup', JSON.stringify(item));
    } else {
      sessionStorage.removeItem('selectedFindTimeResultItemGroup');
    }
  }


  // find time second result grouped by therapist
  get selectedFindTimeResultItem(): FindTimeResultItem {
    return JSON.parse(sessionStorage.getItem('selectedFindTimeResultItem') || 'null');
  }
  set selectedFindTimeResultItem(item: FindTimeResultItem) {
    if (item) {
      sessionStorage.setItem('selectedFindTimeResultItem', JSON.stringify(item));
    } else {
      sessionStorage.removeItem('selectedFindTimeResultItem');
    }
  }


  // find time second result grouped by therapist
  get bookVisitItem(): VisitItem{
    const obj = JSON.parse(sessionStorage.getItem('bookVisitItem') || 'null');
    if (obj) {
      return new VisitItem(obj);
    }
    return null;
  }
  set bookVisitItem(item: VisitItem) {
    if (item) {
      sessionStorage.setItem('bookVisitItem', JSON.stringify(item));
    } else {
      sessionStorage.removeItem('bookVisitItem');
    }
  }

  // find time second result grouped by therapist
  get visitItem(): VisitItem {
    const obj = JSON.parse(sessionStorage.getItem('visitItem'));
    if (obj) {
      return new VisitItem(obj);
    }
    return null;
  }
  set visitItem(item: VisitItem) {
    if (item) {
      sessionStorage.setItem('visitItem', JSON.stringify(item));
    } else {
      sessionStorage.removeItem('visitItem');
    }
  }

  // store\fetch the logged users language. stores when loging in (updateDefaultCulture()) , and fetches when refreshing pages (initLanguages()).
  get userLanguage(): string {
    return sessionStorage.getItem('userLanguage');
  }
  set userLanguage(lang: string) {
    if (lang) {
      sessionStorage.setItem('userLanguage', lang);
    } else {
      sessionStorage.removeItem('userLanguage');
    }
  }

  // string, used as flag. sets\gets where the findtime was started from (customerDetails/scheduler...). solves 'cancel' button unwanted loop issues.
  get findTimeCancelButtonRoute(): string {
    return sessionStorage.getItem('findTimeCancelButtonRoute');
  }
  set findTimeCancelButtonRoute(origin: string) {
    if (origin) {
      sessionStorage.setItem('findTimeCancelButtonRoute', origin);
    } else {
      sessionStorage.removeItem('findTimeCancelButtonRoute');
    }
  }

  get newCustomerBusinessID(): number {
    const id = sessionStorage.getItem('newCustomerBusinessID') || '0';
    return +id; // the (+) sing convert string to number
  }
  set newCustomerBusinessID(val: number) {
    if (val !== undefined && val !== null) {
      sessionStorage.setItem('newCustomerBusinessID', `${val}`);
    } else {
      sessionStorage.removeItem('newCustomerBusinessID');
    }
  }

  get newCustomerBackUrl(): string {
    return sessionStorage.getItem('newCustomerBackUrl') || '';
  }
  set newCustomerBackUrl(val: string) {
    if (val !== undefined && val !== null) {
      sessionStorage.setItem('newCustomerBackUrl', val);
    } else {
      sessionStorage.removeItem('newCustomerBackUrl');
    }
  }

  get newCustomerBusinessList(): SelectListItem[] {
    return JSON.parse(sessionStorage.getItem('newCustomerBusinessList') || '[]');

  }
  set newCustomerBusinessList(val: SelectListItem[]) {
    if (val !== undefined && val !== null) {
      sessionStorage.setItem('newCustomerBusinessList', JSON.stringify(val));
    } else {
      sessionStorage.removeItem('newCustomerBusinessList');
    }
  }

  get textEditorData(): string {
    return sessionStorage.getItem('textEditorData') || '';
  }
  set textEditorData(str: string) {
    str = str || '';
    sessionStorage.setItem('textEditorData', str);
  }

  get navigateBackData(): any[] {
    return JSON.parse(sessionStorage.getItem('navigateBackData') || '[]') || [];
  }
  set navigateBackData(data: any[]) {
    if (data) {
      sessionStorage.setItem('navigateBackData', JSON.stringify(data));
    } else {
      sessionStorage.removeItem('navigateBackData');
    }

  }

  get prePaymentRequestData(): any {
    return JSON.parse(sessionStorage.getItem('prePaymentRequestData'));
  }
  set prePaymentRequestData(data: any) {
    if (data) {
      sessionStorage.setItem('prePaymentRequestData', JSON.stringify(data));
    } else {
      sessionStorage.removeItem('prePaymentRequestData');
    }
  }

  /**
   *  any: {
   *    customerEmail: string,
   *    therapistEmail:string,
   *    customerID:number,   
   *    therapistID: number, 
   *    businessID: number,
   *    formID: number,
   *    formDataID: number
   * }
   */
  get fillFormData(): any {
    return JSON.parse(sessionStorage.getItem('fillFormData'));
  }
  set fillFormData(data: any) {
    if (data) {
      sessionStorage.setItem('fillFormData', JSON.stringify(data));
    } else {
      sessionStorage.removeItem('fillFormData');
    }
  }


  clearFindTimeData() {
    this.appointment = null;
    this.formStateFindTime = null;
    this.treatments = null;
    this.priceListCodes = null;
    this.visitItem = null;
    this.selectedFindTimeResultItem = null;
    this.selectedFindTimeResultItemGroup = null;
  }
}
